<template>
	<div class="scanner scanner__canvas">
		<video id="preview" style="" class="scanner__preview" v-show="preview"></video>
		<div class="scanner__laser" :class="{'flash': flashLaser}"></div>
		<button class="scanner__button" @click="switchCamera" :disabled="!canSwitch">
			<img src="../images/camera.png" alt="Switch camera" v-if="canSwitch">
		</button>

		<div
			v-if="debug && debugVisible"
			id="console"
			v-html="debugOutput"
		/>
	</div>
</template>

<script>

	import * as ZXing from "@zxing/library";
	import $ from "jquery";

	export default {
		name: "scanner",

		data: function () {
			return {
				codeReader: null,
				videoDevice: null,
				loading: false,
				showLaser: false,
				flashLaser: false,
				cameras: [],
				selectedCamera: null,
				debug: false,
				debugVisible: false,
				debugLog: ['DEBUG LOG'],
			};
		},

		props: {
			preview: {
				default: true,
			},
			logs: {
				default: [],
			},

			showingMember: {
				default: null,
			},

			forceReload: {
				default: 0,
			},
		},

		watch: {
			showingMember: function (newVal, oldVal) {
				if(newVal === null) {
					this.setupCamera();
				}
			},

			forceReload: function (newVal, oldVal) {
				this.setupCamera();
			},
		},

		mounted() {
			this.codeReader = new ZXing.BrowserMultiFormatReader(null, 200);
			this.setupCamera();
		},

		computed: {
			canSwitch: function () {
				return this.cameras.length > 1;
			},

			debugOutput: function () {
				return this.debugLog.concat(this.logs).join('<br />');
			},
		},

		methods: {
			info: function (success, label, item = null) {
				if (!this.debug && !success) {
					window.bugsnagObj.notify({
						message: label,
						data: item,
					});
					return;
				}

				if (typeof item === 'string' || item instanceof String) {
					this.debugLog.push(item);
				} else {
					this.debugLog.push(JSON.stringify(item));
				}
			},

			setupCamera: function () {
				$(() => {
					this.codeReader
						.getVideoInputDevices()
						.then(videoInputDevices => {
							this.cameras = videoInputDevices;
							this.scannerStart();
						})
						.catch(err => console.error(err));
				});
			},

			// Action on QR code scanner start
			scannerStart: function () {
				let self = this;
				this.showLaser = true;
				this.codeReader
					.decodeFromInputVideoDevice(undefined, 'preview')
					.then(result => {
						this.flashLaser = true;
						this.info(true, 'Scanned barcode', {
							code: result.text,
							format: result.format,
						});

						// Format 4 is our barcode
						if (result.format === 4) {
							this.scanned('barcode', result.text);
						} else if (result.format === 11) {
							// Format 11 is our QR code
							this.scanned('qrcode', result.text);
						} else {
							this.info(false, 'Unsupported barcode format', {
								code: result.text,
								format: result.format,
							});
						}
					})
					.catch(function (err) {
						self.info(false, 'Something went wrong setting up the scanner', {
							err: err,
						});

						console.error(err);
					});
			},

			scanned: function (type, text) {

				if(this.showingMember){
					return;
				}

				this.showLaser = false;
				const data = {type: type, text: text};
				this.$emit('scanned', data);

				this.info(true, 'Scanned barcode', {
					type: type,
					text: text,
				});

				setTimeout(() => {
					this.flashLaser = false;
				}, 300)
				// setTimeout(() => {
				// 	this.scannerStart();
				// }, 3000);
			},

			switchCamera: function () {
				this.selectedCamera = this.selectedCamera ? 0 : 1;
				this.setupCamera();
			},
		},
	}
</script>

<style scoped lang="scss">
	.scanner {
		width: 100%;
		overflow: hidden;
		max-height: 100vh;


		&__canvas {
			z-index: 100;
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			overflow: hidden;
			background-color: #1e1e1e;
			padding: 60px 0 160px;
			display: flex;
			align-items: center;
		}

		&__preview {
			max-width: 100%;
			margin: 0 auto;
		}

		// Fullscreen result after a scan
		// Display message in center
		&__result {
			width: 100%;
			height: 100%;
			align-items: center;
			text-align: center;
			justify-content: center;
			background: transparent;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			z-index: 999;
			display: none;

			&.show {
				display: block;
			}
		}

		&__laser {
			position: fixed;
			height: 4px;
			background-color: #FF0000;
			width: 80%;
			max-width: 250px;
			margin-left: auto;
			margin-right: auto;
			left: 0;
			right: 0;
			top: 50%;
			opacity: .6;
			box-shadow: 0 0 10px #FF0000;

			&.flash {
				opacity: 1;
				box-shadow: 0 0 20px #FF0000;
			}
		}

		&__loading {
			position: absolute;
			z-index: 999;
			background: #000000f2;
			width: 100%;
			height: 100%;
			justify-content: center;
			align-items: center;
			top: 0;
			display: none;

			&__img {
				width: 125px;
			}
		}

		&__button {
			display: block;
			position: fixed;
			z-index: 900;
			top: 0;
			background: none;
			border: none;
			outline: none;
			right: 0;
			height: 58px;
			width: 60px;
			opacity: .8;
			padding: 10px;
			background: #000;
			box-sizing: border-box;

			img {
				max-height: 100%;
				max-width: 100%;
			}
		}


		&.loading .scanner__loading {
			display: flex;
		}

		.card {
			padding: 15px;
			text-align: center;
		}

		.btn--light {
			background: #fff;
		}
	}

	#console {
		width: 100%;
		max-width: 100vh;
		text-overflow: wrap;
		background: black;
		color: greenyellow;
		text-align: left;
		padding: 10px;
		font-weight: bold;
		position: fixed;
		top: 50px;
		z-index: 500;
	}
</style>


// WEBPACK FOOTER //
// src/components/ScannerComponent.vue